import { useDebouncedValue as useDebouncedValueMantine } from '@mantine/hooks';

export const useDebouncedValue = useDebouncedValueMantine;
